import { ACTION_TYPES } from './transactions.constant';

export const servicePost = (payload) => ({
  type: ACTION_TYPES.SERVICE.POST,
  payload,
});

export const servicePatch = (payload) => ({
  type: ACTION_TYPES.SERVICE.PATCH,
  payload,
});

export const fetchStart = () => ({
  type: ACTION_TYPES.FETCH.START,
});

export const fetchSuccess = (payload) => ({
  type: ACTION_TYPES.FETCH.SUCCESS,
  payload,
});

export const fetchError = () => ({
  type: ACTION_TYPES.FETCH.ERROR,
});

export const updateCurrent = (payload) => ({
  type: ACTION_TYPES.UPDATE.CURRENT,
  payload,
});

export const resetState = () => ({
  type: ACTION_TYPES.RESET.STATE,
});
